<template>
  <footer class="footer">
    <div class="footer-main">
      <div class="footer-col logo-col">
        <img src="@/assets/logo.png" alt="logo" class="footer-logo" width="40" height="40" loading="lazy" />
        <span class="footer-brand">聚宝铺</span>
      </div>
      <div class="footer-col">
        <div class="footer-col-title">聚宝铺</div>
        <a href="#" @click.prevent="onDownloadClick">下载插件</a>
        <!-- <a href="#">介绍</a> -->
        <a href="#" @click.prevent="onDocClick">产品手册</a>
        <router-link to="/pricing">价格</router-link>
      </div>
      <div class="footer-col">
        <div class="footer-col-title">支持</div>
        <a href="#" @click.prevent="onRegisterClick">新客户注册</a>
        <!-- <a href="#">高级专家支持</a> -->
      </div>
      <div class="footer-col contact-col">
        <div class="footer-col-title">联系我们</div>
        <div class="footer-contact">18559206137</div>
        <img src="https://yootiao.top/jbp/img/wxqc.png" alt="微信二维码" class="footer-qrcode" width="80" height="80" loading="lazy" />
        <div class="footer-qrcode-label">微信扫码</div>
      </div>
    </div>
    <div class="footer-copyright">
      <div>
        Copyright © 2025-2025 聚宝铺 版权所有<br />
        <!-- 粤ICP备2025410561号-2 -->
      </div>
    </div>
  </footer>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router'
import { checkVersion } from '../api/admin'

const router = useRouter()
const route = useRoute()

function onPriceClick() {
  if (route.path !== '/') {
    router.push('/').then(() => {
      setTimeout(() => {
        const el = document.getElementById('yearly-vip')
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 400)
    })
  } else {
    const el = document.getElementById('yearly-vip')
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

function onDocClick() {
  window.open('https://qcn0uu72n24r.feishu.cn/wiki/OLTSwVOeLiFIL5kg64vctp4EnWl', '_blank')
}

async function onDownloadClick() {
  try {
    const res = await checkVersion('0.0.0')
    if (res.code === 200 && res.data && res.data.downPath) {
      window.location.href = res.data.downPath
    } else {
      alert(res.message || '获取下载链接失败')
    }
  } catch (e) {
    alert('网络错误，获取下载链接失败')
  }
}

function onRegisterClick() {
  router.push('/register')
}
</script>

<style scoped>
.footer {
  width: 100%;
  background: #fff;
  padding: 0 0 24px 0;
  color: #222;
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -2px 16px #4ba3fa22;
  margin-top: 64px;
}
.footer-main {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 48px 0 24px 24px; /* 左侧增加24px间隔 */
  gap: 32px;
}
.footer-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 140px;
}
.logo-col {
  flex-direction: row;
  align-items: center;
  gap: 12px;
  min-width: 180px;
}
.footer-logo {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eaf3fb;
}
.footer-brand {
  font-size: 1.6rem;
  font-weight: bold;
  color: #222;
}
.footer-col-title {
  font-weight: bold;
  margin-bottom: 4px;
  color: #222;
}
.footer-col a {
  color: #222;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.2s;
}
.footer-col a:hover {
  color: #4b70eb;
}
.footer-contact {
  font-size: 1.08rem;
  color: #222;
  margin-bottom: 6px;
}
.footer-qrcode {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background: #eaf3fb;
  margin-bottom: 4px;
}
.footer-qrcode-label {
  color: #888;
  font-size: 0.95rem;
}
.footer-copyright {
  border-top: 1px solid #eee;
  margin-top: 24px;
  padding-top: 16px;
  text-align: center;
  color: #888;
  font-size: 0.98rem;
}
@media (max-width: 900px) {
  .footer-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    padding: 32px 0 16px 16px; /* 左侧间隔16px */
  }
  .logo-col {
    margin-bottom: 12px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 0 0 10px 0;
    border-radius: 16px 16px 0 0;
    margin-top: 24px;
    box-shadow: 0 -2px 12px #4ba3fa11;
  }
  .footer-main {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 14px 0 8px 16px; /* 左侧间隔16px */
  }
  .footer-col, .logo-col {
    flex-direction: row;
    align-items: center;
    gap: 6px;
    min-width: 0;
    margin-bottom: 2px;
    font-size: 0.98rem;
  }
  .footer-logo {
    width: 28px;
    height: 28px;
    border-radius: 6px;
  }
  .footer-brand {
    font-size: 1.08rem;
    font-weight: bold;
    color: #2979ff;
    margin-left: 4px;
  }
  .footer-col-title {
    font-size: 0.98rem;
    margin-bottom: 0;
    color: #2979ff;
    font-weight: 600;
  }
  .footer-col a {
    font-size: 0.95rem;
    margin-bottom: 0;
    color: #2979ff;
  }
  .footer-contact {
    font-size: 0.95rem;
    margin-bottom: 2px;
  }
  .footer-qrcode {
    width: 48px;
    height: 48px;
    border-radius: 6px;
    margin-bottom: 2px;
  }
  .footer-qrcode-label {
    font-size: 0.85rem;
    margin-bottom: 0;
  }
  .footer-copyright {
    font-size: 0.82rem;
    padding-top: 6px;
    margin-top: 6px;
    text-align: center;
    color: #888;
  }
}
</style>